import type { ReactElement } from 'react';
import { Users } from 'lucide-react';
import type { InstalledToolListItem } from '@kirin/api-client/contracts/shadow-ai-installed-tools';
import { LoggedInUserCountsChips } from '../LoggedInUserCountsChips';

export function UsersCell({
  row,
}: {
  row: InstalledToolListItem;
}): ReactElement {
  return (
    <span className="inline-flex items-center gap-1.5 font-medium text-muted-foreground">
      <Users className="h-3.5 w-3.5" />
      {row.userCount}
    </span>
  );
}

export function LoggedInUserCell({
  row,
}: {
  row: InstalledToolListItem;
}): ReactElement {
  return <LoggedInUserCountsChips counts={row.loggedInUserCounts} />;
}
